import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Action from './components/Action';
import { compose } from 'recompose';
import { SelectWithLabel } from '../../../../Dispatch/RouteExecution/Pickups/PickupManagement/components/Select';
import NewHolidayInfo from './components/NewHolidayInfo';
import appConstants from '../../../../../../appConstants';
import { postData } from '../../../../../../api/componentAPIs';
import { getCustomerHolidayValidationsProps } from './utils';

const styles = (theme) => ({
  container: {
    display: 'flex',
    padding: '6 14 12 14',
    minHeight: '20%',
    justifyContent: 'flex-end',
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: '4px',
    flexDirection: 'column',
    maxWidth: 340
  },
  inputClass: {
    width: '100%'
  },
  label: {
    minWidth: 82,
    marginTop: 6,
    alignSelf: 'flex-start'
  },
  holidayTitle: {
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    color: theme.TextColor,
    marginBottom: 8
  },
  disableClick: {
    pointerEvents: 'none',
    opacity: 0.7
  }
});

const AddHoliday = ({
  classes,
  onClose,
  refreshData,
  enqueueSnackbar,
  openModule,
  customerDetails,
  holidayOptions
}) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [isUpdateInProgress, setIsUpdateInProgress] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState({});
  const [error, setError] = useState(null);

  const handleAddHoliday = () => {
    setIsUpdateInProgress(true);
    const requestData = {
      holidayId: selectedHoliday.value,
      customerCode: customerDetails.customerCode,
      terminalId: customerDetails.terminalId,
      isCustomerSpecificHolidays: false,
      holidayName: null,
      description: null,
      holidayStartDate: null,
      holidayEndDate: null
    }; // send default value in terminal holiday for(isCustomerSpecificHolidays,holidayName,description,holidayStartDate,holidayEndDate)
    postData('SaveCustomerHolidays', requestData)
      .then((response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          enqueueSnackbar(`Holiday '${selectedHoliday.label}' added successfully`, {
            variant: 'success',
            style: { wordBreak: 'break-word' }
          });
          refreshData(selectedHoliday?.holidayDate);
          onClose([response.data.holidayId]);
        } else {
          handleError({ statusCode: response.status });
        }
      })
      .catch(() => {
        handleError();
      });
  };

  const handleError = ({ statusCode }) => {
    if (statusCode !== 403) {
      enqueueSnackbar(`Error while adding holiday '${selectedHoliday.label}'`, {
        variant: 'error',
        style: { wordBreak: 'break-word' }
      });
    }
    setIsUpdateInProgress(false);
  };

  const handleAddHolidayError = (option) => {
    let errorMessage = option ? null : '* Required';
    const { isHolidayAlreadyAdded, isSameDayAlreadyAdded } = getCustomerHolidayValidationsProps(
      customerDetails.holidays,
      option
    );
    if (isHolidayAlreadyAdded) {
      errorMessage = 'Holiday is already added!';
    } else if (isSameDayAlreadyAdded) {
      errorMessage = 'Another holiday is already added on the same day!';
    }
    setError(errorMessage);
  };

  const onChangeHoliday = (option) => {
    handleAddHolidayError(option);
    setIsDisabled(!option);
    setSelectedHoliday(option);
  };

  const onVisitHolidayClick = () => {
    openModule(appConstants.NAV_URLS.SETTINGS, 'holidayManagement');
  };
  
  const isDisabledForShippers = !customerDetails.customerCode;

  return (
    <>
      <div className={`${classes.container} ${isUpdateInProgress ? classes.disableClick : null}`}>
        <span className={classes.holidayTitle}>ADD HOLIDAY</span>
        <SelectWithLabel
          label="Holiday Name"
          id="holiday"
          data={holidayOptions ?? []}
          value={selectedHoliday?.value ?? null}
          inputClass={classes.inputClass}
          onChange={onChangeHoliday}
          labelClass={classes.label}
          error={error}
          autoFocus
          textFieldProps={{
            id: 'holidayName',
            label: 'Enter holiday name or date',
            variant: 'outlined',
            helperText: error
          }}
        />
        <Action
          onClose={onClose}
          isDisabled={isDisabled || error || isDisabledForShippers}
          isUpdateInProgress={isUpdateInProgress}
          onClick={handleAddHoliday}
        />
      </div>
      <NewHolidayInfo onClick={onVisitHolidayClick} />
    </>
  );
};

export default compose(withStyles(styles))(AddHoliday);
